module.exports = __webpack_public_path__ + "static/img/img8.3799409d.png";